module.exports = __webpack_public_path__ + "static/media/thumb_angularJSListaTarefas.5cd77f84.jpg";